/**
 * Main store function
 */
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import Cookies from 'universal-cookie';

import rootReducer from './reducers';
import { loadTiming } from './modules/App/loadTiming';

function isRemote() {
  const cookies = new Cookies();
  return !!cookies.get('rlog');
}

export function configureStore(initialState = {}) {
  const middlewares = [];

  if (process.env.RUN_ENV === 'development' || isRemote()) {
    const { createLogger } = require('redux-logger');

    middlewares.push(
      createLogger({
        duration: true,
        predicate: (getState, action) => action.type !== 'CTA_SUCCESS'
      })
    );
  }

  middlewares.push(thunk, loadTiming);

  // Middleware and store enhancers
  const enhancers = [applyMiddleware(...middlewares)];

  const store = createStore(rootReducer, initialState, compose(...enhancers));

  // For hot reloading reducers
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      const nextReducer = require('./reducers').default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}
